"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_container_query_1 = require("react-container-query");
var close_button_1 = tslib_1.__importDefault(require("../../../ui-components/close-button/close-button"));
var overlay_focus_lock_1 = tslib_1.__importDefault(require("../overlay-focus-lock/overlay-focus-lock"));
var closable_overlay_scss_1 = tslib_1.__importDefault(require("./closable-overlay.scss"));
var containerQuery = (_a = {},
    _a[closable_overlay_scss_1.default['min-width-250px']] = {
        minWidth: 250,
        maxWidth: 499,
    },
    _a[closable_overlay_scss_1.default['min-width-500px']] = {
        minWidth: 500,
        maxWidth: 979,
    },
    _a[closable_overlay_scss_1.default['min-width-980px']] = {
        minWidth: 980,
    },
    _a);
var ClosableOverlay = /** @class */ (function (_super) {
    tslib_1.__extends(ClosableOverlay, _super);
    function ClosableOverlay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.closeOnEsc = function (e) {
            if (e.keyCode === 27) {
                _this.props.onClose();
            }
        };
        _this.closeOnBodyClick = function () {
            var _a = _this.props, closeOnBodyClick = _a.closeOnBodyClick, onClose = _a.onClose;
            if (closeOnBodyClick) {
                onClose();
            }
        };
        _this.handleCloseButtonClick = function (event) {
            event.stopPropagation();
            _this.props.onClose(event);
        };
        _this.renderOverlay = function (queryClasses) {
            var _a, _b;
            var _c = _this.props, children = _c.children, isFullWidth = _c.isFullWidth, isFullWidthForced = _c.isFullWidthForced, isInFullScreen = _c.isInFullScreen, posterUrl = _c.posterUrl, contentClassName = _c.contentClassName, isVisible = _c.isVisible, ariaLabel = _c.ariaLabel, isRTL = _c.isRTL;
            var styleNames = (0, classnames_1.default)(closable_overlay_scss_1.default['info-overlay'], tslib_1.__assign((_a = {}, _a[closable_overlay_scss_1.default['full-width']] = isFullWidth, _a), queryClasses));
            var contentStyleNames = (0, classnames_1.default)(closable_overlay_scss_1.default.content, contentClassName, (_b = {},
                _b[closable_overlay_scss_1.default['full-screen']] = isInFullScreen && !isFullWidthForced,
                _b[closable_overlay_scss_1.default.half] = !isFullWidth && !posterUrl,
                _b));
            return (react_1.default.createElement(overlay_focus_lock_1.default, { isEnabled: isVisible },
                react_1.default.createElement("div", { className: styleNames, "data-hook": _this.props.dataHook, role: "dialog", "aria-label": ariaLabel, onClick: _this.closeOnBodyClick, dir: isRTL ? 'rtl' : 'ltr' },
                    react_1.default.createElement("div", { className: contentStyleNames }, children),
                    _this.getCloseButton())));
        };
        return _this;
    }
    ClosableOverlay.prototype.componentDidMount = function () {
        window.addEventListener('keyup', this.closeOnEsc);
    };
    ClosableOverlay.prototype.componentWillUnmount = function () {
        window.removeEventListener('keyup', this.closeOnEsc);
    };
    ClosableOverlay.prototype.getCloseButton = function () {
        var _a;
        var isRTL = this.props.isRTL;
        var closeStyles = (0, classnames_1.default)(closable_overlay_scss_1.default.close, (_a = {},
            _a[closable_overlay_scss_1.default.rtl] = isRTL,
            _a[closable_overlay_scss_1.default.ltr] = !isRTL,
            _a));
        return (react_1.default.createElement(close_button_1.default, { className: closeStyles, theme: "dark", dataHook: "close-overlay", onClick: this.handleCloseButtonClick, ariaLabel: this.props.closeButtonAriaLabel }));
    };
    ClosableOverlay.prototype.render = function () {
        return (react_1.default.createElement(react_container_query_1.ContainerQuery, { query: containerQuery }, this.renderOverlay));
    };
    ClosableOverlay.propTypes = {};
    return ClosableOverlay;
}(react_1.default.Component));
exports.default = ClosableOverlay;
//# sourceMappingURL=closable-overlay.js.map